var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShower(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M23.1667 9L20.4055 25.1637C20.3751 25.3448 20.2955 25.5139 20.1754 25.6527C20.0553 25.7915 19.8993 25.8946 19.7245 25.9506C19.5497 26.0066 19.3629 26.0135 19.1844 25.9704C19.006 25.9273 18.8429 25.8359 18.713 25.7062L6.46296 13.4563C6.33333 13.3263 6.24196 13.1632 6.19886 12.9848C6.15576 12.8064 6.1626 12.6195 6.21862 12.4447C6.27465 12.2699 6.3777 12.1139 6.51649 11.9938C6.65528 11.8737 6.82445 11.7941 7.00546 11.7638L23.1667 9Z",
    fill: "#E85D04"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.9165 29.5C7.9165 30.1904 7.35686 30.75 6.6665 30.75C5.97615 30.75 5.4165 30.1904 5.4165 29.5C5.4165 28.8096 5.97615 28.25 6.6665 28.25C7.35686 28.25 7.9165 28.8096 7.9165 29.5Z",
    fill: "#E85D04",
    stroke: "#E85D04",
    strokeWidth: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9165 25.5C11.9165 26.1904 11.3569 26.75 10.6665 26.75C9.97615 26.75 9.4165 26.1904 9.4165 25.5C9.4165 24.8096 9.97615 24.25 10.6665 24.25C11.3569 24.25 11.9165 24.8096 11.9165 25.5Z",
    fill: "#E85D04",
    stroke: "#E85D04",
    strokeWidth: 0.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.9165 25.5C3.9165 26.1904 3.35686 26.75 2.6665 26.75C1.97615 26.75 1.4165 26.1904 1.4165 25.5C1.4165 24.8096 1.97615 24.25 2.6665 24.25C3.35686 24.25 3.9165 24.8096 3.9165 25.5Z",
    fill: "#E85D04",
    stroke: "#E85D04",
    strokeWidth: 0.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.6665 23C7.49493 23 8.1665 22.3284 8.1665 21.5C8.1665 20.6716 7.49493 20 6.6665 20C5.83808 20 5.1665 20.6716 5.1665 21.5C5.1665 22.3284 5.83808 23 6.6665 23Z",
    fill: "#E85D04"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M31.1667 5H27.1667L23.1667 9M23.1667 9L20.4055 25.1637C20.3751 25.3448 20.2955 25.5139 20.1754 25.6527C20.0553 25.7915 19.8993 25.8946 19.7245 25.9506C19.5497 26.0066 19.3629 26.0135 19.1844 25.9704C19.006 25.9273 18.8429 25.8359 18.713 25.7062L6.46296 13.4563C6.33333 13.3263 6.24196 13.1632 6.19886 12.9848C6.15576 12.8064 6.1626 12.6195 6.21862 12.4447C6.27465 12.2699 6.3777 12.1139 6.51649 11.9938C6.65528 11.8737 6.82445 11.7941 7.00546 11.7638L23.1667 9Z",
    stroke: "#E85D04",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShower);
export default __webpack_public_path__ + "static/media/Shower.361875897b5f7fa0d6998a301c8d79c7.svg";
export { ForwardRef as ReactComponent };